import { type RefObject, useEffect, useRef } from 'react'

import { trackEvent } from '~/shared/lib/analytics'

import { DOCUMENT_PDF_FIRST_SCROLL } from '../config'
import { useStepSession } from './step-session-context'

export function useFirstScroll(scrollableRef: RefObject<HTMLElement | null>) {
  const { step, documentKey } = useStepSession()
  const hasFiredRef = useRef(false)

  useEffect(() => {
    hasFiredRef.current = false
  }, [step, documentKey])

  useEffect(() => {
    const el = scrollableRef.current
    if (!el) return

    const handler = () => {
      if (hasFiredRef.current) return
      hasFiredRef.current = true
      trackEvent(DOCUMENT_PDF_FIRST_SCROLL, { step, document_key: documentKey })
      el.removeEventListener('scroll', handler)
    }

    el.addEventListener('scroll', handler, { passive: true })
    return () => el.removeEventListener('scroll', handler)
  }, [scrollableRef, step, documentKey])
}
